import Lottie from "react-lottie";
import myra from "../../../shared/assets/images/Myra.jpg";
import animationData from "../../../shared/scss/animations/animated.json";

interface AnimatedSpeakingProps {
  isSpeaking: boolean;
}

export const AnimatedSpeaking = ({ isSpeaking }: AnimatedSpeakingProps) => {
  const defaultOptions = {
    loop: true,
    autoplay: isSpeaking,
    animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  return (
    <div>
      <img
        src={myra}
        alt="Myra"
        className="object-cover object-top w-full h-full"
      />
      {isSpeaking && (
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
          <Lottie
            options={defaultOptions}
            height={100}
            width={100}
            isStopped={!isSpeaking}
            isPaused={!isSpeaking}
          />
        </div>
      )}
    </div>
  );
};
